import * as React from 'react';

import { GetReviewsQuery } from '@notino/shared/definitions/types';

import { Filters } from './Filters';
import { Sorting } from './Sorting';
import { SortFilterBarNewDesignWrapper } from './styled';

interface SortFilterBarProps {
  reviewsAndFilters: GetReviewsQuery['reviewsAndFilters'];
  productReviewCount: number;
}

export const SortFilterBar: React.FC<SortFilterBarProps> = ({
  reviewsAndFilters = {},
  productReviewCount,
}) => {
  if (productReviewCount === 0) {
    return null;
  }

  return (
    <SortFilterBarNewDesignWrapper>
      <Filters filters={reviewsAndFilters?.filter ?? null} />
      <Sorting reviewsData={reviewsAndFilters?.data ?? null} />
    </SortFilterBarNewDesignWrapper>
  );
};
